import { UserMenuMainInfo } from 'src/pages/ManageTasksChatPage/components/ConversationsHeader/components/UserMenuMainInfo';
import { SectionFooter } from './components/SectionFooter';
import styles from './UserMenuSection.module.scss';
import { useGetUser } from 'src/hooks';
// import { SupportButton } from './components/SupportButton';
import { SignOutButton } from './components/SignOutButton';
import { GuestAuthLinks } from 'src/pages/AuthPages/components/GuestAuthLinks';
import { ThemeSelector } from './components/ThemeSelector';
import { CompanyLinks } from './components/CompanyLinks';
import { SubscriptionButtons } from 'src/v2/components/LeftSidePanel/components/UserMenuSection/components/SubscriptionButtons';
import { ManageAccountButtons } from 'src/v2/components/LeftSidePanel/components/UserMenuSection/components/ManageAccountButtons';
import { TierUpsellSection } from 'src/v2/components/LeftSidePanel/components/TierUpsellSection';
import { CookieButton } from './components/CookieButton';

export const UserMenuSection = () => {
  const { isOpenTier } = useGetUser();

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <UserMenuMainInfo />

        <TierUpsellSection />

        {!isOpenTier && (
          <div className={styles.sectionWrapper}>
            <h5 className={styles.sectionTitle}>Subscription</h5>
            <SubscriptionButtons />
          </div>
        )}

        <div className={styles.sectionWrapper}>
          <h5 className={styles.sectionTitle}>Account management</h5>
          {!isOpenTier && <ManageAccountButtons />}

          <CookieButton />

          <div className={styles.sectionContentWrapper}>
            <ThemeSelector />
          </div>
        </div>

        {/* <div className={styles.sectionWrapper}>
          <h5 className={styles.sectionTitle}>Help</h5>
          <div className={styles.sectionContentWrapper}>
            <SupportButton />
          </div>
        </div> */}

        <div className={styles.sectionWrapper}>
          <h5 className={styles.sectionTitle}>Ninja</h5>
          <div className={styles.sectionContentWrapper}>
            <CompanyLinks />
          </div>
        </div>

        <hr className="divider" />
        <div className={styles.sectionContentWrapper}>
          {isOpenTier ? (
            <GuestAuthLinks
              dataGTM="Settings-auth-buttons-signup"
              className={styles.authLinks}
            />
          ) : (
            <SignOutButton />
          )}
        </div>
      </div>
      <SectionFooter />
    </div>
  );
};
